import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import "rxjs/add/observable/fromPromise";
import {Reservation, ReservationsService} from "../../../../services/reservations.service";
import {Router} from "@angular/router";

@Component({
  selector: 'reservation-event-modal',
  templateUrl: 'reservation-event-modal.component.html'
})

export class ReservationEventModalComponent implements OnInit {
  reservationId: number;
  reservation: Reservation;

  static open(modalService: NgbModal, reservationId: number) {
    const modalRef = modalService.open(ReservationEventModalComponent);
    modalRef.componentInstance.reservationId = reservationId;
  }

  constructor(private activeModal: NgbActiveModal, private reservationService: ReservationsService, private router: Router) {
  }

  ngOnInit() {
    this.reservationService
      .getReservationsDetails(this.reservationId)
      .subscribe(data => this.reservation = data);
  }

  close() {
    this.activeModal.close();
  }

  goToDetails() {
    this.router.navigate([`/reservations/${this.reservationId}`]);
    this.close();
  }

}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/calendar/modals/reservation-event-modal.component.ts